<template>
  <v-container py-0>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2 pa-2>
        <v-card>
          <v-toolbar flat dense color="primary" dark>
            <v-toolbar-title>
              {{ $tc('fields.typeSubscriptions.typePayment', 2) }}
            </v-toolbar-title>
            <v-spacer />
            <v-dialog v-model="dialog" scrollable width="1024" lazy>
              <template v-if="paymentsTypes.length" #activator="{ on }">
                <v-btn small flat v-on="on">
                  {{ $t('action.buttons.new') }}
                </v-btn>
              </template>
              <v-card>
                <v-toolbar flat dense color="primary" dark>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer />
                  <v-toolbar-items>
                    <v-btn dark icon @click="close">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex md4 xs12 px-2>
                      <v-select
                        v-model="editedItem.type"
                        v-validate="'required'"
                        :items="paymentsTypes"
                        clearable
                        :label="
                          $tc('fields.typeSubscriptions.typePayment') + ' *'
                        "
                        :data-vv-name="
                          $tc('fields.typeSubscriptions.typePayment')
                        "
                        :error-messages="
                          errors.collect(
                            $tc('fields.typeSubscriptions.typePayment')
                          )
                        "
                        @change="filterCountries"
                      />
                    </v-flex>
                    <v-flex md4 xs12 px-2>
                      <v-select
                        v-model="editedItem.countryId"
                        v-validate="'required'"
                        :items="filteredCountries"
                        clearable
                        :label="$tc('models.country') + ' *'"
                        :data-vv-name="$tc('models.country')"
                        :error-messages="errors.collect($tc('models.country'))"
                      />
                    </v-flex>
                    <v-flex md4 xs12 px-2>
                      <v-currency-field
                        v-model="editedItem.price"
                        v-validate="'decimal|min_value:0'"
                        :label="$t('fields.typeSubscriptions.price') + ' *'"
                        suffix="€"
                        clearable
                        :data-vv-name="$t('fields.typeSubscriptions.price')"
                        :error-messages="
                          errors.collect($t('fields.typeSubscriptions.price'))
                        "
                      />
                      <!-- <v-text-field
                        v-model.number="editedItem.price"
                        type="number"
                        :label="$t('fields.typeSubscriptions.price') + ' *'"
                        :data-vv-name="$t('fields.typeSubscriptions.price')"
                        :error-messages="
                          errors.collect($t('fields.typeSubscriptions.price'))
                        "
                        v-validate="'required|decimal'"
                      ></v-text-field> -->
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                  <template>
                    <span style="color: red">(*) &nbsp;</span>
                    <span>{{ $t('action.messages.fieldRequired') }}</span>
                  </template>
                  <v-spacer />
                  <!-- <meta-button @click="clear" type="reset" /> -->
                  <meta-button
                    :type="editedIndex === -1 ? 'add' : 'update'"
                    @click="save"
                  />
                  <meta-button type="cancel" @click="close" />
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-card-text class="pa-0">
            <div class="v-table__overflow">
              <table
                class="v-datatable v-table theme--light"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th>{{ $t('fields.global.actions') }}</th>
                    <th>{{ $t('models.country') }}</th>
                    <th>{{ $tc('fields.typeSubscriptions.typePayment') }}</th>
                    <th>{{ $t('fields.typeSubscriptions.price') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index + 20">
                    <td class="justify-center layout px-0">
                      <v-icon
                        class="mr-2"
                        color="success"
                        @click="editItem(item)"
                      >
                        edit
                      </v-icon>
                      <v-icon color="error" @click="ifDeleteItem(index)">
                        delete
                      </v-icon>
                    </td>
                    <td class="text-xs-center">
                      {{
                        countriesList.find(
                          (country) => country.value === item.countryId
                        )
                          ? countriesList.find(
                              (country) => country.value === item.countryId
                            ).text
                          : $t('action.buttons.all')
                      }}
                    </td>
                    <td class="text-xs-center">
                      {{
                        $t(
                          `fields.typeSubscriptions.typesPayment.${
                            item.type.split('-')[0]
                          }`
                        )
                      }}
                    </td>

                    <td class="text-xs-center">
                      {{ item.price | currency }}
                    </td>
                  </tr>
                  <tr v-if="!items.length">
                    <td colspan="9" class="text-xs-center">
                      {{ $vuetify.t('$vuetify.noDataText') }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
        </v-card>
        <dialog-delete
          :dialog.sync="dialogDelete"
          @delete="deleteItem(indexDelete)"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import VCurrencyField from '@/components/widgets/Input/VCurrencyField'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import { apiAxios } from '@/helpers/api'
export default {
  name: 'TypePayments',
  components: {
    DialogDelete,
    VCurrencyField,
  },
  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => ({
    dialog: false,
    editedIndex: -1,
    editedItem: {
      type: '',
      countryId: null,
      price: '',
    },
    defaultItem: {
      type: '',
      price: '0',
    },
    dialogDelete: false,
    countriesList: [],
    filteredCountries: [],
  }),

  computed: {
    ...mapGetters({
      paymentsTypes: 'typeSubscriptions/paymentsTypes',
    }),
    items: {
      get() {
        return Array.isArray(this.value) ? this.value : []
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    formTitle() {
      return this.editedIndex !== -1
        ? this.$t('titles.global.updateModel', {
            field: this.$tc('fields.typeSubscriptions.typePayment'),
          })
        : this.$t('titles.global.newModel', {
            field: this.$tc('fields.typeSubscriptions.typePayment'),
          })
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  mounted() {
    this.fetchCountries()
  },

  methods: {
    fetchCountries() {
      apiAxios.post(`countries/select?limit=0`).then((response) => {
        this.countriesList = response.data.data.country
        this.countriesList.push({
          value: 'all',
          text: this.$t('action.buttons.all'),
        })
        this.countriesList.unshift(
          this.countriesList.splice(this.countriesList.lastIndexOf(), 1)[0]
        )
      })
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.type = item.type.split('-')[0]
      this.dialog = true
      this.filterCountries()
    },

    ifDeleteItem(index) {
      this.indexDelete = index
      this.dialogDelete = true
    },
    deleteItem(indexDelete) {
      this.items.splice(indexDelete, 1)
      this.dialogDelete = false
      this.indexDelete = ''
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.$validator.reset()
      }, 300)
    },

    save() {
      this.validate().then((valid) => {
        if (!valid) return
        if (this.editedIndex > -1) {
          Object.assign(this.items[this.editedIndex], this.editedItem)
        } else {
          this.items.push(this.editedItem)
        }
        this.close()
      })
    },
    filterCountries() {
      const data =
        this.editedIndex !== -1
          ? this.items.filter(
              (item) =>
                item.type.split('-')[0] ===
                  this.editedItem.type.split('-')[0] &&
                item._id !== this.editedItem._id
            )
          : this.items.filter(
              (item) =>
                item.type.split('-')[0] === this.editedItem.type.split('-')[0]
            )
      this.filteredCountries = this.countriesList.filter(
        (country) => !data.some((item) => item.countryId === country.value)
      )
    },
  },
}
</script>
